import { configureStore } from './configureStore';

import { currentFilter as filter } from '../reducers/content/filter';
import { dataReducer as data } from '../reducers/shared/index/data';
import { bulkActionsReducer as bulk } from '../reducers/shared/index/bulk';
import massActions from '../reducers/shared/index/mass_actions';
import defaultView from '../reducers/content/defaultView';

export const createStore = initialState =>
  configureStore(initialState, {
    filter,
    data,
    bulk,
    defaultView,
    massActions,
  });
